import { FC, memo } from 'react';
import {
  FULL_DATE_FORMAT,
  FULL_DATE_WITHOUT_YEAR_FORMAT
} from 'constants/dates';
import dayjs from 'dayjs';
import { useTranslation } from 'react-i18next';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import { VideoCameraOutlined } from '@ant-design/icons';
import { useCallButton } from 'hooks';
import {
  convertSecondsToMMSS,
  JOIN_TIMER_SECONDS
} from '@medicusunion/front-utils';

import { ICallButtonProps } from './types';
import { StyledButton, StyledCallCounter } from './styles';

dayjs.extend(customParseFormat);

const CallButton: FC<ICallButtonProps> = ({ date, fullWidth, onJoinClick }) => {
  const { t } = useTranslation();

  const seconds = useCallButton(date);

  if (seconds <= JOIN_TIMER_SECONDS) {
    const secondsFormatted =
      seconds > 0 ? ` (${convertSecondsToMMSS(seconds)})` : '';

    return (
      <StyledButton
        type="primary"
        key="join-call"
        size="large"
        style={{ display: 'flex', alignItems: 'center' }}
        onClick={onJoinClick}
        block={fullWidth}
      >
        <VideoCameraOutlined style={{ fontSize: 22 }} />
        {t('appointments_details.join_call')}
        {secondsFormatted}
      </StyledButton>
    );
  }

  const formattedDate = dayjs(date, FULL_DATE_FORMAT).format(
    FULL_DATE_WITHOUT_YEAR_FORMAT
  );

  return (
    <StyledCallCounter>
      {t('appointments_details.call_starts_in')} {formattedDate}
    </StyledCallCounter>
  );
};

export default memo(CallButton);
